import { render, staticRenderFns } from "./StatusPassosItem.vue?vue&type=template&id=962171be&"
import script from "./StatusPassosItem.vue?vue&type=script&lang=js&"
export * from "./StatusPassosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/workflow/StatusPassosItem.vue
// module id = 352
// module chunks = 28